import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import * as colors from './colors';

const theme = createTheme({
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: colors.PRIMARY_COLOR,
            // dark: will be calculated from palette.primary.main,
            contrastText: colors.WHITE_COLOR,
        },
        secondary: {
            // light: will be calculated from palette.primary.main,
            main: colors.SECONDARY_COLOR,
            // dark: will be calculated from palette.primary.main,
            contrastText: colors.WHITE_COLOR,
        },
        warning: {
            // light: will be calculated from palette.primary.main,
            main: colors.WARNING_COLOR,
            // dark: will be calculated from palette.primary.main,
            contrastText: colors.WHITE_COLOR,
        },
        info: {
            // light: will be calculated from palette.primary.main,
            main: colors.INFO_COLOR,
            // dark: will be calculated from palette.primary.main,
            contrastText: colors.WHITE_COLOR,
        },
        light: {
            // light: will be calculated from palette.primary.main,
            main: colors.WHITE_COLOR,
            // dark: will be calculated from palette.primary.main,
            contrastText: colors.BLACK_COLOR,
        },
    },
    typography: {
        fontFamily: "'Poppins', sans-serif",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                contained: {
                    boxShadow: 'none',
                    borderRadius: '10px',
                    fontSize: '12px',
                },
                outlined: {
                    borderRadius: '10px',
                    minHeight: '40px',
                    fontSize: '12px',
                },
            },
        },
    },
});

export default function Theme(props) {
    return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
}
